import { Injectable } from '@angular/core';
import { Observable, throwError, of, Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { retry, catchError, map, finalize, tap, filter, debounceTime, distinctUntilChanged, mergeMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocationModel } from "src/app/location/location";
import { AuthService } from "src/app/auth.service";
import { environment } from '../../../environments/environment';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HvacSubmissionService {

  private baseURL = environment.baseUrl;

  constructor(private http: HttpClient, private messager: MessagerComponent){}




  updateErrorsFalse(locID){
    return this.http.post(this.baseURL + '/rhAPI/locations/hvacErrorsFalse/' + locID,{}, {observe:'body'});
  }

  updateSystemStamp(id, sys): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/updateSysStamp/' + id, sys ,{observe: 'body'});
  }

  updateEquipmentStamp(id, eq): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/updateEqStamp/' + id, eq, {observe:'body'});
  }

  updateDesignStamp(id, des): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/updateDesStamp/' + id, des, {observe: 'body'});
  }

  getSubmittedHVAC(lid): Observable<any>{
    return this.http.get(this.baseURL + '/rhAPI/locations/getSubmission/' + lid, {observe: 'body'});
  }

  getHvacData(lid): Observable<any>{
    return this.http.get(this.baseURL + '/rhAPI/locations/getHVACdata/' + lid, {observe: 'body'});
  }

  getOneDesign(did): Observable<any>{
    return this.http.get(this.baseURL + '/rhAPI/getDesign/' + did, {observe: 'body'});
  }

  getHVACdataLegacy(lid): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/locations/getHVACdataLegacy/' + lid, {observe: 'body'});
  }

  getHVACequipValues(sbmt_dsn_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/locations/getHVACequipBySbmtId/' + sbmt_dsn_id, {observe: 'body'});
  }

  getRaterHvacReview(id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/location/getRaterHVAC/' + id, {observe: 'body'});
  }

  getSubmittedDesign(location_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/locations/getSubmission/' + location_id, {observe: 'body'});
  }

  getLastRaterform(location_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/raterform/getLastHVAC/' + location_id, {observe:'body'} );
  }

}
